/* Importing the configureStore function from the reduxjs/toolkit package. */
import { configureStore } from '@reduxjs/toolkit';

/* This is importing the reducers from the redux store. */
import defaultReducer from '../features/default/defaultSlice';
import accountReducer from '../features/account/accountSlice';
import conditionReducer from '../features/condition/conditionSlice';
import deviceReducer from '../features/device/deviceSlice';
import encounterReducer from '../features/encounter/encounterSlice';
import locationReducer from '../features/location/locationSlice';
import patientReducer from '../features/patient/patientSlice';
import obsevrvationReducer from '../features/observation/observationSlice';
import questionnaireReducer from '../features/questionnaire/questionnaireSlice';
import questionnaireResponseReducer from '../features/questionnaireResponse/questionnaireResponseSlice';
// import userReducer from '../features/user/userSlice'

/* Creating a store with the reducers. */
const store = configureStore({
  reducer: {
    default: defaultReducer,
    account: accountReducer,
    condition: conditionReducer,
    device: deviceReducer,
    encounter: encounterReducer,
    location: locationReducer,
    patient: patientReducer,
    observation: obsevrvationReducer,
    questionnaire: questionnaireReducer,
    questionnaireResponse: questionnaireResponseReducer,
    // user: userReducer
  },
});

/* Exporting the store to be used in the index.js file. */
export default store;
